import React, { useMemo, useState } from 'react';
import { useBhimaBulkData } from '../BhimaBulkDataContext';
import BhimaHighcharts from './BhimaHighcharts';
import { getJSONObject } from 'utils/helper';

const BhimaChart = ({ title, apiParams, chartType }) => {
    const { loading: bulkLoading, dataByKey } = useBhimaBulkData();
    const [chartData, setChartData] = useState(null);

    const response = useMemo(() => {
        if (apiParams?.chartid == null || apiParams?.dashboard_id == null) return null;
        return dataByKey[`${apiParams.dashboard_id}:${apiParams.chartid}`] ?? null;
    }, [dataByKey, apiParams?.dashboard_id, apiParams?.chartid]);

    React.useEffect(() => {
        if (!response) return;
        const result = response?.results?.[0];
        if (!result || result.error) return;
        const highchartCode = getJSONObject(result.highchart_code);
        const dfData = getJSONObject(result.df_data) || [];
        setChartData({
            data: Array.isArray(dfData) ? dfData : [],
            dataToPlot: highchartCode,
            chartType: highchartCode?.plot_type || 'line',
            title: result.question || title
        });
    }, [response, title]);

    if (bulkLoading) {
        return (
            <div className="bhima-card" style={{ justifyContent: 'center', height: '100%', minHeight: '350px' }}>
                <div style={{ fontFamily: 'Cinzel', color: '#3e2b26' }}>Loading Chart...</div>
            </div>
        );
    }

    if (!chartData && apiParams) {
        return (
            <div className="bhima-card" style={{ justifyContent: 'center', height: '100%', minHeight: '350px' }}>
                <div className="bhima-card-title">{title}</div>
                <div className="bhima-no-data">No data available</div>
            </div>
        );
    }

    return (
        <div className="bhima-card" style={{ height: '100%', minHeight: '400px', padding: '15px' }}>
            <div className="bhima-card-title" style={{ marginBottom: '5px' }}>
                {title || chartData?.title}
            </div>
            <div style={{ flex: 1, width: '100%', position: 'relative' }}>
                {chartData && (
                    <BhimaHighcharts 
                        chartTitle={title || chartData.title}
                        data={chartData.data}
                        dataToPlot={chartData.dataToPlot}
                        chartTypeOuter={chartType || chartData.chartType}
                    />
                )}
            </div>
        </div>
    );
};

export default BhimaChart;
